type TimeIntervalMinutes = {
  startMinutes: number;
  endMinutes: number;
};

class TransportValidationUtil {
  // transport time is outside workhours
  static hasOutsideWorkHours(
    intervals: TimeIntervalMinutes[],
    shiftStartMinutes: number,
    shiftEndMinutes: number,
  ): boolean {
    return intervals.some(
      (interval) =>
        interval.startMinutes < shiftStartMinutes ||
        interval.endMinutes > shiftEndMinutes,
    );
  }

  // transport times are overlapping
  static hasOverlap(intervals: TimeIntervalMinutes[]): boolean {
    const intervalsSortedByStart = [...intervals].sort(
      (a, b) => a.startMinutes - b.startMinutes,
    );

    return intervalsSortedByStart.some((interval, index) => {
      if (index === 0) return false;
      return (
        interval.startMinutes < intervalsSortedByStart[index - 1].endMinutes
      );
    });
  }

  // transport time doesn't fill workhours
  static getTotalMinutes(intervals: TimeIntervalMinutes[]) {
    return intervals.reduce(
      (sum, interval) => sum + (interval.endMinutes - interval.startMinutes),
      0,
    );
  }
  static getWorktimeMinutes(
    shiftStartMinutes: number,
    shiftEndMinutes: number,
  ) {
    return shiftEndMinutes - shiftStartMinutes;
  }
}

export default TransportValidationUtil;
